import React from 'react';
import FileHelper from '../../../../../../core/helpers/FileHelper';
import IDHelpers from '../../../../../../core/helpers/IDHelper';
import Block from '../../../../../components/Block';
import FileUploaded from './itemFile';

function FilesUploadedList(props: any) {
  const {
    acceptedFiles,
    handleRemoveSingleFile,
    maxFileSize,
    allowedFormats,
    handleRemoveFormatError
  } = props;

  const isAllowedFormat = (f: any) => {
    const ext = `.${FileHelper.getFileExtension(f.name)}`;
    const formats = allowedFormats.split(',');
    return formats.includes(ext.toLowerCase());
  };

  return (
    <Block customized data-testid="cmp-FilesUploadedList">
      {acceptedFiles.map((file: any, index: number) => (
        <FileUploaded
          key={IDHelpers.generateID()}
          labelName={file.name}
          labelSize={file.size}
          maxFileSize={maxFileSize}
          dataFile={file}
          index={index}
          handleRemoveSingleFile={() => {
            handleRemoveSingleFile(file);
          }}
          formatAllowed={isAllowedFormat(file)}
          handleRemoveFormatError={handleRemoveFormatError}
        />
      ))}
    </Block>
  );
}

export default FilesUploadedList;
